export default "__VITE_ASSET__BPyERuHa__"